module.exports = __webpack_public_path__ + "media/front/images/facebook-b7f9c6f3af3ea32ccefd82685d6f484e.svg";